import { FC, useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Drawer, Divider } from '@mui/material';
import VendorItem from './primaryMenu/VendorItem';
import { navItems } from 'src/routes';
import useVendor from 'src/hooks/useVendor';
import '../../theme/partials/GlobalNav.css';
import useAuth from 'src/hooks/useAuth';

interface GlobalSidebarNavProps {
  onMobileClose: () => void;
  openMobile: boolean;
}

const GlobalSidebarNav: FC<React.PropsWithChildren<GlobalSidebarNavProps>> = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();
  const { vendor } = useVendor();
  const [activeNavItem, setActiveNavItem] = useState<string | null>(null);
  const { hasImpersonateVendorAuth, hasBuyerOrCategoryManagerVendorPortalRole } = useAuth();

  useEffect(() => {
    const urlSegment = location.pathname.split('/').pop();
    setActiveNavItem(urlSegment);
  }, [location]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
      className="global-sidebar"
    >
      {/* <Box className="global-header__menu"></Box> */}

      <Box className="global-sidebar__menu">
        <Box className="global-sidebar__menu__item">
          <VendorItem isPopover />
          <Divider sx={{ my: 3 }} />
        </Box>
        {vendor &&
          vendor.numberString &&
          navItems.map((item, index) => {
            return (
              <div key={index + 'i'}>
                <Box className={`global-header__menu__item ${item.path.split('/')[1] === activeNavItem ? 'active' : ''}`}>
                  <div className="global-nav__item-link">
                    <RouterLink to={`/${vendor.numberString + item.path}`}>{item.name}</RouterLink>
                  </div>
                </Box>
                <Divider sx={{ my: 3 }} />
              </div>
            );
          })}

        {/* Bulk Upload */}
        {hasImpersonateVendorAuth() && (
          <div key={'1000'}>
            <Box className={`global-header__menu__item ${activeNavItem === 'BulkUserUpload' ? 'active' : ''}`}>
              <div className='global-nav__item-link'>
                <RouterLink to={'/BulkUserUpload'}>Bulk User Upload</RouterLink>
              </div>
            </Box>
            <Divider sx={{ my: 3 }} />
          </div>
        )}

        {hasBuyerOrCategoryManagerVendorPortalRole() && (
          <div key={'vendor-settings-sidebar'}>
            <Box className={`global-header__menu__item ${activeNavItem === 'VendorSettings' ? 'active' : ''}`}>
              <div className='global-nav__item-link'>
                <RouterLink to={'/VendorSettings'}>Vendor Settings</RouterLink>
              </div>
            </Box>
            <Divider sx={{ my: 3 }} />
          </div>
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={openMobile}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          width: 315,
        },
      }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

GlobalSidebarNav.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default GlobalSidebarNav;
